export default {
  title: 'Indicatori funcționali',
  subtitle: 'Activează sau dezactivează funcțiile platformei pentru {{company}}.',
  no_company: 'Selectați un restaurant pentru a gestiona indicatorii funcționali.',
  columns: {
    feature: 'Funcție',
    status: 'Stare',
  },
  flags: {
    paypal_standalone: {
      name: 'PayPal (direct)',
      description:
        'Permite acestui restaurant să primească plăți PayPal direct în propriul cont PayPal. Activat implicit pentru restaurantele partenerilor facturați de Foodamigos, unde taxa de serviciu pentru client este, de asemenea, percepută pe aceste plăți, iar partea platformei este facturată partenerului.',
    },
    vip_free_flyers: {
      name: 'Flyere lunare gratuite',
      description:
        'Trimite automat 500 de flyere promoționale lunar acestui restaurant (implicit: activ pentru nivelul VIP și Star).',
    },
    custom_store_seo: {
      name: 'SEO personalizat magazin',
      description: 'Permite acestui restaurant să gestioneze setările SEO personalizate pentru magazinul online.',
    },
    external_printer: {
      name: 'Imprimantă de chitanțe externă',
      description:
        'Permite acestui restaurant să conecteze o imprimantă de rețea la aplicația terminalului, în loc să folosească imprimanta integrată.',
    },
    stripe_payment_element: {
      name: 'Finalizare comandă cu Stripe Payment Element',
      description:
        'Lasă contul Stripe propriu al restaurantului să decidă ce metode de plată oferă finalizarea comenzii. Activează-o doar după ce platforma Stripe a configurat metodele de plată pentru conturile conectate.',
    },
  },
  toasts: {
    enabled: 'Funcție activată.',
    disabled: 'Funcție dezactivată.',
    error: 'Funcția nu a putut fi actualizată. Vă rugăm să încercați din nou.',
    load_error: 'Indicatorii funcționali nu au putut fi încărcați.',
  },
};
